module.exports = __webpack_public_path__ + "img/mrbeast.0e7a0423.png";